function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.041,12.872a6.957,6.957,0,1,1,9.833,0l-4.368,4.375a.773.773,0,0,1-1.1,0L5.041,12.872Zm4.917-2.6A2.319,2.319,0,1,0,7.638,7.956,2.319,2.319,0,0,0,9.957,10.275Z",
  transform: "translate(-3 -0.992)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12,1a6.957,6.957,0,0,1,4.917,11.874l-4.368,4.375a.773.773,0,0,1-.549.232v-7.2a2.319,2.319,0,0,0,0-4.638V1Z",
  transform: "translate(-5.043 -0.994)"
});

var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.915,
    height: 16.488,
    viewBox: "0 0 13.915 16.488"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Marker.2d79fec1.svg";
export { SvgMarker as ReactComponent };